import { LegalPage } from "@/components/legal/legal-page";
import { LEGAL_DRAFT, LEGAL_UPDATED } from "@/pages/legal/legal-meta";

/**
 * Privatumo politika — /privatumas, public.
 *
 * PLACEHOLDER TEXT (issue #40), replaced whole by the lawyer's. What it lists
 * is what the code does today — keep it that way while it is the draft: a
 * privacy page that misdescribes the app is worse than a short one.
 */
export default function PrivacyPage() {
  return (
    <LegalPage title="Privatumo politika" updated={LEGAL_UPDATED} draft={LEGAL_DRAFT}>
      <section>
        <h2>1. Duomenų valdytojas</h2>
        <p>
          [Įmonės pavadinimas, kodas, adresas]. Klausimus apie duomenis siųskite
          adresu [el. pašto adresas].
        </p>
      </section>

      <section>
        <h2>2. Kokius duomenis renkame</h2>
        <ul>
          <li>
            <strong>Paskyros:</strong> vardas, el. pašto adresas, slaptažodis (tik
            užšifruotas) arba „Google“ paskyros identifikatorius ir nuotrauka.
          </li>
          <li>
            <strong>Apie vaiką:</strong> gimimo metai (ir, jei nurodyta, mėnuo bei
            diena), klasė — pagal juos parenkamos užduotys.
          </li>
          <li>
            <strong>Mokymasis:</strong> atsakymai, sesijos, pažanga pagal temas,
            pokalbiai su AI pagalbininku, pranešimai apie netinkamas užduotis.
          </li>
          <li>
            <strong>Tai, ką įrašo suaugęs:</strong> pvz. vaiko pomėgiai, kuriais
            pritaikomos užduotys.
          </li>
          <li>
            <strong>Techniniai:</strong> klaidų ir greitaveikos žurnalai, IP adresas
            (bandymų prisijungti ribojimui).
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Kam juos naudojame</h2>
        <ul>
          <li>Kad parinktume užduotis ir rodytume pažangą.</li>
          <li>Kad AI pagalbininkas galėtų paaiškinti klaidą.</li>
          <li>Kad išsiųstume patvirtinimo, slaptažodžio atkūrimo ir kvietimo laiškus.</li>
          <li>Kad apsaugotume paskyras ir taisytume klaidas.</li>
        </ul>
        <p>[Teisinis pagrindas kiekvienam tikslui.]</p>
      </section>

      <section>
        <h2>4. Dirbtinis intelektas</h2>
        <p>
          Užduoties tekstas, vaiko atsakymas, pokalbio žinutės ir suaugusiojo
          įrašyti pomėgiai siunčiami AI paslaugų teikėjams: „Google“ (Gemini) ir
          „DeepSeek“ (Kinija). <strong>Vaiko vardo jiems nesiunčiame.</strong> Šie
          teikėjai gali saugoti gautus duomenis ir naudoti juos savo modeliams
          tobulinti, todėl į laukelius apie vaiką prašome nerašyti vardų, mokyklos ar
          adreso. [Duomenų perdavimas už ES ribų ir jo pagrindas.]
        </p>
      </section>

      <section>
        <h2>5. Kiti paslaugų teikėjai</h2>
        <ul>
          <li>„Google“ — prisijungimas su „Google“ paskyra.</li>
          <li>„Stripe“ — mokėjimai (kortelės duomenų mes nematome).</li>
          <li>„Zoho ZeptoMail“ — el. laiškų siuntimas.</li>
          <li>[Serverių talpinimo paslaugų teikėjas ir šalis.]</li>
        </ul>
      </section>

      <section>
        <h2>6. Slapukai</h2>
        <p>
          Naudojame vieną būtiną slapuką — prisijungimui palaikyti. Reklamos ar
          analitikos slapukų nenaudojame. Naršyklėje taip pat įsimename kelias
          nuostatas (pvz. paskutinį pasirinktą filtrą).
        </p>
      </section>

      <section>
        <h2>7. Kiek laiko saugome</h2>
        <ul>
          <li>Paskyros ir mokymosi duomenis — kol paskyra egzistuoja.</li>
          <li>Klaidų ir greitaveikos žurnalus — 30 dienų.</li>
          <li>[AI užklausų žurnalų saugojimo laikas.]</li>
        </ul>
      </section>

      <section>
        <h2>8. Jūsų teisės</h2>
        <p>
          Galite paprašyti parodyti, ištaisyti ar ištrinti savo ir savo vaiko
          duomenis, apriboti jų tvarkymą ar perkelti juos. Parašykite mums. Taip pat
          galite kreiptis į Valstybinę duomenų apsaugos inspekciją.
        </p>
      </section>

      <section>
        <h2>9. Vaikai</h2>
        <p>
          [Tėvų sutikimas, kai vaikas jaunesnis nei 14 metų, ir kaip jis gaunamas.]
        </p>
      </section>
    </LegalPage>
  );
}
